export const EnabledPlayDesktopVirtualDeviceTypeId = '3ae3d1ed-97b7-4572-a57a-00d4724270a0';
